import * as React from "react";

const { Component } = React;

import * as ClientStore from "./ClientStore";
import { Input, Button, FormGroup, Label } from "../components/Modal";

interface CreateClientProps {
    organization: string;
}

interface CreateClientState {
    client: {
        id: string;
        name: string;
        redirectUri: string;
        postLogoutRedirectUri: string;
        backChannelLogoutUri: string;
        grantType: string;
        organization: string;
        secrets?: any;
    };
    isLoaded: boolean;
    isError: boolean;
    error?: any;
}

export default class CreateClient extends Component<CreateClientProps, CreateClientState> {
    constructor(props) {
        super(props);
        this.state = {
            client: {
                id: undefined,
                name: undefined,
                redirectUri: undefined,
                postLogoutRedirectUri: undefined,
                backChannelLogoutUri: undefined,
                grantType: undefined,
                organization: props.organization,
                secrets: undefined,
            },
            isLoaded: false,
            isError: false,
        };
    }

    error = (message) => {
        this.setState({
            isError: true,
            error: {
                message,
            },
        });
    };

    clearError = () => {
        this.setState({
            isError: false,
            error: {
                message: "",
            },
        });
    };

    createClient = () => {
        if (!this.state.client.name) {
            this.error("Specify a client name");
            return;
        }

        if (!this.state.client.grantType) {
            this.error("Choose a grant type");
            return;
        }

        this.clearError();

        ClientStore.CreateClient(this.state.client).then(
            (result) => {
                this.setState({
                    isLoaded: true,
                    client: result.data.client,
                });
            },
            (error) => {
                this.setState({
                    isError: true,
                    error,
                });
            }
        );
    };

    handleNameChange = (e) => {
        var name = e.target.value.trim();

        this.setState((prevState) => {
            prevState.client.name = name;

            return prevState;
        });
    };

    handleRedirectUriChange = (e) => {
        var name = e.target.value.trim();

        this.setState((prevState) => {
            prevState.client.redirectUri = name;

            return prevState;
        });
    };

    handlePostLogoutRedirectUriChange = (e) => {
        var name = e.target.value.trim();

        this.setState((prevState) => {
            prevState.client.postLogoutRedirectUri = name;

            return prevState;
        });
    };

    handleBackChannelLogoutUriChange = (e) => {
        var name = e.target.value.trim();

        this.setState((prevState) => {
            prevState.client.backChannelLogoutUri = name;

            return prevState;
        });
    };

    handleGrantTypeChange = (e) => {
        var name = e.target.value.trim();

        this.setState((prevState) => {
            prevState.client.grantType = name;

            return prevState;
        });
    };

    render() {
        return (
            <div className="space-y-6">
                <FormGroup>
                    <Label required>Name</Label>
                    <Input type="text" onChange={this.handleNameChange} />
                </FormGroup>

                <FormGroup>
                    <Label>Redirect Uri</Label>
                    <Input type="text" onChange={this.handleRedirectUriChange} />
                </FormGroup>

                <FormGroup>
                    <Label>Post Logout Redirect Uri</Label>
                    <Input type="text" onChange={this.handlePostLogoutRedirectUriChange} />
                </FormGroup>

                <FormGroup>
                    <Label>Back Channel Logout Uri</Label>
                    <Input type="text" onChange={this.handleBackChannelLogoutUriChange} />
                </FormGroup>

                <FormGroup>
                    <Label required>Grant Type</Label>
                    <Input type="select" onChange={this.handleGrantTypeChange} defaultValue="">
                        <option value="">- Choose One -</option>
                        <option value="implicit">Implicit (Web no server interaction)</option>
                        <option value="hybrid">Hybrid (Web with server interaction)</option>
                        <option value="client_credentials">Client Credentials (No user interaction)</option>
                        <option value="urn:ietf:params:oauth:grant-type:device_code">Device</option>
                    </Input>
                </FormGroup>
                
                <div className="flex justify-end">
                    <Button variant="primary" onClick={this.createClient}>
                        Create
                    </Button>
                </div>
                {this.state.isLoaded && (
                    <div className="mt-6 p-4 bg-green-50 border border-green-200 rounded-md">
                        <h4 className="text-lg font-medium text-green-800 mb-4">Client Created Successfully</h4>
                        <div className="space-y-3">
                            <div>
                                <Label>ID</Label>
                                <div className="text-sm text-gray-900 font-mono">{this.state.client.id}</div>
                            </div>
                            <div>
                                <Label>Name</Label>
                                <div className="text-sm text-gray-900">{this.state.client.name}</div>
                            </div>
                            <div>
                                <Label>Secret</Label>
                                <div className="text-sm text-gray-900 font-mono bg-gray-100 p-2 rounded break-all">
                                    {this.state.client.secrets && this.state.client.secrets[0].value}
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {this.state.isError && (
                    <div className="mt-4 p-4 bg-red-50 border border-red-200 rounded-md">
                        <div className="text-red-800">{this.state.error.message}</div>
                    </div>
                )}
            </div>
        );
    }
}
